export function createPersistedStorage<T>(key: string, opts?: { raw?: boolean }) {
  const isRaw = opts?.raw ?? false;

  const write = (value: T) => {
    try {
      sessionStorage.setItem(key, isRaw ? (value as unknown as string) : JSON.stringify(value));
    } catch {
    }
  };

  const clear = () => {
    try {
      sessionStorage.removeItem(key);
    } catch {
    }
  };

  const read = (): T | null => {
    try {
      const stored = sessionStorage.getItem(key);
      if (stored === null) return null;
      return isRaw ? (stored as unknown as T) : (JSON.parse(stored) as T);
    } catch {
      return null;
    }
  };

  return { read, write, clear };
}
